import styled from '@emotion/styled';
import theme from '@24hr/resursbank-theme/ya-bank';

export const StyledToggleSectionsContainer = styled.div`
    padding: 0 ${theme.spacing.indent};
`;
